export function disableScroll() {
  document.ontouchmove = (e) => {
    e.preventDefault();
  };
}

export function enableScroll() {
  document.ontouchmove = () => {
    return true;
  };
}
